<template>
  <a-form
    id="accountLoginForm"
    :form="form"
    class="login-form"
    @submit="loginSubmit"
  >
    <a-form-item>
      <a-input
        v-decorator="[
          'userName',
          {
            rules: [
              { required: true, message: '请输入手机号' },
              {
                pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$|^[5|6|8|9][0-9]{7}$/,
                message: '请输入正确的手机号',
              },
            ],
          },
        ]"
        placeholder="请输入手机号"
      >
        <a-icon
          slot="prefix"
          type="mobile"
          style="color: rgba(0, 0, 0, 0.25)"
        />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input
        v-decorator="[
          'userPwd',
          { rules: [{ required: true, message: '请输入密码' }] },
        ]"
        type="password"
        placeholder="请输入密码"
      >
        <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
      </a-input>
    </a-form-item>
    <a-button type="primary" html-type="submit" class="login-form-button">
      登录
    </a-button>
    <!-- <div class="mt-2">
      <a class="login-form-forgot" href="http://www.snai-rz.com/forget">
        忘记密码
      </a>
    </div> -->
  </a-form>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("account");
import md5 from "js-md5";
//=========================遗漏
//================
// mapState
export default {
  beforeCreate() {
    // this.form = this.$form.createForm(this);
  },
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
    };
  },
  methods: {
    ...mapActions(["accountLoginAction", "getStudentInfo"]),

    loginSubmit(e) {
      e.preventDefault();
      const isDuringDate = sessionStorage.getItem("isDuringDate");

      if (!JSON.parse(isDuringDate)) {
        this.$warning({
          content: "系统暂未开放",
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
        });
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          values.userPwd = md5(values.userPwd);
          this.accountLoginAction(values).then((res) => {
            this.loginStatusJudge(res.data);
          });
        }
      });
    },
    loginStatusJudge(data) {
      if (data.status == 2000) {
        localStorage.setItem("apply_studentInfo", JSON.stringify(data));
        if (
          data.data.examEnrollInfoDto.currentStatus == 13 ||
          data.data.examEnrollInfoDto.currentStatus == 15
        ) {
          this.$router.replace(
            `/admission?id=${data.data.examEnrollInfoDto.enrollInfoId}`
          );
        } else {
          this.$warning({
            content: "没有您的准考证信息",
            okText: "知道了",
            okType: "primary",
            maskClosable: true,
          });
        }
      } else {
        this.$warning({
          content: data.message,
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
        });
      }
    },
  },
};
</script>
<style>
#accountLoginForm .login-form {
  max-width: 300px;
}
#accountLoginForm .login-form-button {
  width: 100%;
}
.login-form-forgot {
  margin-top: -10px;
}
.login-form-button {
  border-radius: 24px;
}
</style>
